/*
 * Page Name
 */

(function ($) {
    new WOW().init();
    var ind_top_swiper = new Swiper(".ind_top_swiper", {
        loop: true,
        centeredSlides: true,
        autoplay: {
            disableOnInteraction: false,
        },
        speed: 2000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
    });
})(jQuery);